import { render, staticRenderFns } from "./serviceCall.vue?vue&type=template&id=90f1ace2&scoped=true&"
import script from "./serviceCall.vue?vue&type=script&lang=js&"
export * from "./serviceCall.vue?vue&type=script&lang=js&"
import style0 from "./serviceCall.vue?vue&type=style&index=0&id=90f1ace2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f1ace2",
  null
  
)

export default component.exports